export const getStatusRemarks = (item) => {
  const type = item.merchantId ? '帳戶' : '優惠';

  switch (item.status) {
    case 'CREATED':
      return `此${type}已在 ${item.createdAt} 建立。`;
    case 'PENDING':
      return `此${type}正等待審批中。`;
    case 'APPROVED':
    case 'ACTIVATED':
      return `此${type}已在 ${item.createdAt} 審批。`;
    case 'SCHEDULED':
      return `此優惠已排程在 ${item.remarks} 在U Lifestyle 平台發佈。`;
    case 'PUBLISHED':
      return `此優惠已在 ${item.createdAt} 在U Lifestyle 平台發佈。`;
    case 'REJECTED':
      return item.remarks;
    case 'STOPPED':
      return `此優惠已在 ${item.createdAt} 暫停發佈。`;
    case 'EXPIRED':
      return `此優惠已在 ${item.createdAt} 下架。`;
    case 'REMOVED':
      return `此優惠已在 ${item.createdAt} 移除。`;
    case 'CANCELLED':
      return `此優惠已在 ${item.createdAt} 取消審批。`;
    default:
      return null;
  }
};

export const getPaymentCouponRemarks = (item) => {
  switch (item.status) {
    case 'REDEEMED':
      return '訂單已完成';
    case 'REFUND_PENDING':
      return '訂單退款中';
    case 'REFUND_CANCELLED':
      return '訂單退款已取消';
    case 'REFUND_FINISHED':
      return '訂單已退款';
      // return `訂單已退款 ${item.remarks}`;
    default:
      return '';
  }
};

export const getOverViewStatus = (status) => {
  // const type = item.merchantId ? '帳戶' : '優惠';

  let text;
  switch (status) {
    case 'REDEEMED':
      text = '已完成訂單';
      break;
    case 'REFUND_FINISHED':
      text = '已退款訂單';
      break;
    case 'REFUND_PENDING':
      text = '退款中訂單';
      break;
    case 'REDEEMED_COUPON':
      text = '已完成優惠券';
      break;
    case 'REFUND_PENDING_COUPON':
      text = '退款中優惠券';
      break;
    case 'REFUND_FINISHED_COUPON':
      text = '已退款優惠券';
      break;
    case 'TOTAL':
      text = '所有訂單';
      break;
    case 'TOTAL_COUPON':
      text = '所有優惠券';
      break;
    case 'GRAND-TOTAL':
      text = '銷售總額';
      break;
    case 'ACTUAL-TOTAL':
      text = '可收取款款';
      break;
    default:
      text = '審批中';
      break;
  }
  return { text, value: status?.toLowerCase() };
};

export const getPaymentCouponStatus = (status) => {
  // const type = item.merchantId ? '帳戶' : '優惠';

  let text;
  switch (status) {
    case 'REDEEMED':
      text = '已付款';
      break;
    case 'REFUND_FINISHED':
      text = '已退款';
      break;
    case 'FINISHED':
      text = '已退款';
      break;
    case 'REFUND_PENDING':
      text = '退款中';
      break;
    case 'PENDING':
      text = '退款中';
      break;
    case 'REFUND_CANCELLED':
      text = '已取消退款';
      break;
    case 'REDEEMED_COUPON':
      text = '已完成優惠券';
      break;
    case 'REFUND_PENDING_COUPON':
      text = '退款中優惠券';
      break;
    case 'REFUND_FINISHED_COUPON':
      text = '已退款優惠券';
      break;
    default:
      text = '審批中';
      break;
  }
  return { text, value: status?.toLowerCase() };
};

export const getDeliveryStatus = (status) => {
  let text;
  switch (status) {
    case 'DELIVERED':
      text = '已發貨';
      break;
    case 'DELAYED':
      text = '發貨延誤';
      break;
    default:
      text = '未發貨';
      break;
  }
  return { text, value: status?.toLowerCase() };
};

export const getSubMerchantStatus = (status) => {
  let text;
  switch (status) {
    case 'ACTIVATED':
      text = '已啓用';
      break;
    default:
      text = '已停用';
      break;
  }
  return { text, value: status?.toLowerCase() };
};

export const getQrCodeCouponStatus = (status) => {
  let text;
  // console.log(status);
  switch (status) {
    case 'USED':
      text = '已使用優惠券';
      break;
    case 'ACTUAL-USED-TOTAL':
      text = '已使用付費優惠券總值';
      break;
    default:
      text = '審批中';
      break;
  }
  return { text, value: status?.toLowerCase() };
};

export default (status) => {
  let text;
  switch (status) {
    case 'APPROVED':
      text = '已審批';
      break;
    case 'REJECTED':
      text = '已拒絕';
      break;
    case 'EXPIRED':
      text = '已過期';
      break;
    case 'STOPPED':
      text = '已暫停';
      break;
    case 'SCHEDULED':
      text = '已排程';
      break;
    case 'PUBLISHED':
      text = '已發佈';
      break;
    case 'CREATED':
      text = '已建立';
      break;
    case 'ACTIVATED':
      text = '已啓用';
      break;
    case 'INACTIVATED':
      text = '已停用';
      break;
    case 'REMOVED':
      text = '已移除';
      break;
    case 'DRAFT':
      text = '草稿';
      break;
    case 'CANCELLED':
      text = '已取消';
      break;
    case 'PENDING':
    default:
      text = '審批中';
      break;
  }
  return { text, value: status?.toLowerCase() };
};
